import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherList from "@/pages/publisher/PublisherList";

export const Route = createFileRoute("/publisher/")({
  head: () => pageHead("Publisher \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: PublisherList,
});
